<template>
  <div>
    <div>
      <l-editor
        disabled
        :isUploadImg="false"
        v-if="data.type == 'texteditor'"
        :height="data.height"
        v-model="data.default"
        :placeholder="data.placeholder"
      >
      </l-editor>

      <component
        size="mini"
        v-else
        :style="{ width: '100%' }"
        :is="getComponent(data.type)"
        v-model="data.default"
        @input="handleInput"
        @change="handleInput"
        :value="value"
        v-bind="$deepClone(data)"
        :placeholder="data.placeholder"
        :options="myOptions"
        :isNotUpLoad="true"
        :showFileList="uploadFileList"
      >
        <span v-if="data.html" v-html="data.html" />
        <template v-if="['input'].includes(data.type) && data.prepend" #prepend>
          {{ data.prepend }}
        </template>
        <template v-if="['input'].includes(data.type) && data.append" #append>
          {{ data.append }}
        </template>
      </component>
    </div>
  </div>
</template>
<script>
import mixin from "../../mixin";
export default {
  name: "drag-form-item",
  mixins: [mixin()],
  inject: ["formDesign", "formData"],
  props: {
    value: {},
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  computed: {
    uploadFileList() {
      if (this.data.subfield) {
        return "popover";
      } else {
        return true;
      }
    },
  },
  data() {
    return {};
  },
  beforeDestroy() {},
  mounted() {
    this.formData[this.data.field] = this.data.default;

    this.handleInput(this.data.default);
  },
  methods: {
    handleInput(value) {

      this.formData[this.data.field] = value;

      this.$emit("input", value);
    },
    toValueType(type, value) {
      if (!this.$validatenull(value) && !this.$validatenull(type)) {
        switch (type) {
          case "boolean":
            return value == "true";
          case "string":
            return value;
          case "number":
            return Number(value);
        }
      }
    },
  },
};
</script>
